import { BusEvent } from '@web/common';

export class WarehouseProductChangedBusEvent extends BusEvent {}
